var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.deleteIP()}}},[_vm._v("Delete")])}
var staticRenderFns = []

export { render, staticRenderFns }